import { CUSTOMER_ROLES } from "../auth/model";

export const routes = {
    "/assessmentandwellbeing": {
        title: "Manage Stress Risk Assessments",
        authorise: [CUSTOMER_ROLES.sraDepartmentLead, CUSTOMER_ROLES.sraManager],
        "/newstressriskassessment": {
            title: "Create New Stress Risk Assessment"
        },
        "/myresultsForCase/:caseId": {
            title: "View Results"
        },
        "/myresults/:sraEmployeeSectionId": {
            title: "View Results"
        },
        "/myresults": {
            title: "View Results"
        },
        "/overview": {
            title: "Overview"
        }
    }
};
